module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand10-57295b9b2a59ae31f178b35a8acb48c4.jpg";